import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(46, 125, 50, 0.5); }
  70% { box-shadow: 0 0 0 8px rgba(46, 125, 50, 0); }
  100% { box-shadow: 0 0 0 0 rgba(46, 125, 50, 0); }
`

export const MicButton = styled.button<{
  $on: boolean
  $listening: boolean
  $recognized: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: ${({ $on, $recognized, $listening }) =>
    $recognized ? '#fff' : $on && $listening ? '#2e7d32' : '#9e9e9e'};
  background: ${({ $recognized }) => ($recognized ? '#2e7d32' : 'transparent')};
  animation: ${({ $on, $listening, $recognized }) =>
      $on && $listening && !$recognized ? pulse : 'none'}
    1.6s infinite;
  transition: background 0.2s, color 0.2s;
`
